import { useEffect, useState } from "react";
import { IStudentHelpMail } from "../../../../models/student/studentAcademicProfile";
import { connect, useDispatch } from "react-redux";
import { getAlertData } from "../../../../helper/sweet-alert";
import { emailBlockId, helpContact } from "../../../../constants/pageBlocks";
import { setHelpMail } from "../../../../store/slices/common/commonSlice";
import { ISendMail } from "../../../../models/common/IUserProfile";
import { UserRole } from "../../../../constants/RoleEnum";
import {
  createFeedback,
  getToMailId,
} from "../../../../action/common/commonActionCreator";
import {
  getAdvisorHelpMail,
  getFacultyHelpMail,
} from "../../../../action/student/studentHelpMailActionCreator";
import { MultiSelect } from "primereact/multiselect";
import SweetAlert from "react-bootstrap-sweetalert";
import { baseURL } from "../../../../constants/commonConstants";
import { mailValidation } from "../../../../common-functions/commonFunctions";

const StudentHelpModal = (props: IStudentHelpMail) => {
  const {
    setShowCompose,
    SendMail,
    currentUser,
    helpMail,
    selectedContact,
    getFacultyMailId,
    getAdvisorMailId,
    getStudentSuccessMailId,
    contactSuccessMail,
  } = props;

  const [content, setContent] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [toMailIds, setToMailIds] = useState<string[]>([]);
  const [isSending, setIsSending] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [displayName, setDisplayName] = useState<string>("");
  const [toFieldValue, setToFieldValue] = useState<string>("");
  const [tooltipValue, setTooltipValue] = useState<string>("");

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  useEffect(() => {
    switch (selectedContact) {
      case helpContact.contactSuccessStudent:
        getStudentSuccessMailId(emailBlockId.Contact_Student_Success);
        setDisplayName("Contact Success Student");
        break;
      case helpContact.faculty:
        getFacultyMailId();
        setDisplayName("Faculty");
        break;
      case helpContact.advisor:
        getAdvisorMailId();
        setDisplayName("Advisor");
        break;
      default:
        dispatch(setHelpMail([]));
        break;
    }
    return () => {
      dispatch(setHelpMail([]));
    };
  }, [selectedContact]);

  const handleSendMail = () => {
    let alertData = mailValidation(
      subject,
      content,
      selectedContact === helpContact.contactSuccessStudent
        ? [contactSuccessMail]
        : toMailIds
    );
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
      return;
    }

    setIsSending(true);

    const mailData: ISendMail = {
      toEmail:
        selectedContact == helpContact.contactSuccessStudent
          ? [contactSuccessMail]
          : toMailIds,
      subject: subject,
      content: `${content}\<br>\<br>Regards,\<br>${currentUser.displayName
        }\<br>${currentUser.currentRole && UserRole[currentUser.currentRole]}`,
    };
    SendMail(mailData, setAlert);
  };

  const onConfirm = () => {
    setShowAlert(false);
    if (alertType === "success") {
      setShowCompose(false);
      setSubject("");
      setContent("");
      setToMailIds([]);
    }
    setIsSending(false);
  };

  const handleToMailIdsChange = (event: any) => {
    const emails = event.value || [];
    setToMailIds(emails);
    if (emails.length > 4) {
      const mappedNames = emails.map((email: string) => {
        const item = helpMail.find(mail => mail.email === email);
        return item ? item.name : email;
      });
      const firstFour = mappedNames.slice(0, 4);
      const remaining = mappedNames.slice(4);
      setToFieldValue(`${firstFour.join(", ")} + ${remaining.length} more`);
      setTooltipValue(remaining.join(", "));
    }
    else{
      setTooltipValue("");
    }
  };

  useEffect(() => {
  const timeout = setTimeout(() => {
    const mainTag = document.querySelector('.p-multiselect-label') as HTMLDivElement | null;
    if (mainTag) {
      mainTag.title = tooltipValue;
    }
  }, 100);

  return () => clearTimeout(timeout);
}, [tooltipValue]);

  return (
    <>
      <div className="modal-body">
        <h2>Compose</h2>
        <p>
          Summarize your query briefly and send it to the chosen recipient. You
          can expect a reply within 24 hours.
        </p>

        <div className="emailform mt-3">
          <div className="label-to">
            <label htmlFor="">From</label>
            <div className="stude-details">
              <div className="img">
                <img
                  src={currentUser?.image ? baseURL + currentUser.image : ""}
                  alt=""
                  onError={(e) => {
                    e.currentTarget.src =
                      "/assets/images/icon/DefaultImage.jpeg";
                  }}
                />
              </div>
              <div className="desc">
                <h6>{currentUser?.displayName}</h6>
                <p>
                  {currentUser?.currentDepartment?.name} |{" "}
                  <span>{currentUser?.currentCollege?.name}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="multiselect-plugin label-to">
            <label htmlFor="">To</label>
            <div id="htmlselect" className="pt-1 to-email-box">
              {selectedContact === helpContact.contactSuccessStudent ? (
                <input
                  className="w-100 to-email-input"
                  type="text"
                  id="to"
                  value={contactSuccessMail}
                />
              ) : (
                <MultiSelect
                  style={{
                    border: "none",
                    outline: "none",
                  }}
                  placeholder={`Select the ${displayName}`}
                  value={toMailIds}
                  name="mailSelect"
                  options={
                    helpMail?.map((emailData) => ({
                      label: emailData.name,
                      value: emailData.email,
                    })) || []
                  }
                  onChange={(event) => handleToMailIdsChange(event)}
                  maxSelectedLabels={4}
                  selectedItemsLabel={toFieldValue}
                  filter
                  filterBy="label"
                />
              )}
            </div>
          </div>
          <div className="formgroup">
            <label htmlFor="">Subject</label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>
          <div className="formgroup">
            <label htmlFor="">Message</label>
            <textarea
              name=""
              id="message"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="modal-footer mb-4">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSendMail}
          disabled={isSending}
        >
          Send
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={() => setShowCompose(false)}
        >
          Cancel
        </button>
      </div>
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlert(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
    </>
  );
};

const mapDispatchToProps = {
  SendMail: (helpSendMail: ISendMail, callback: Function) =>
    createFeedback(helpSendMail, callback),
  getFacultyMailId: () => getFacultyHelpMail(),
  getAdvisorMailId: () => getAdvisorHelpMail(),
  getStudentSuccessMailId: (emailBlockId: number) => getToMailId(emailBlockId),
};

function mapStateToProps(state: any) {
  return {
    currentUser: state.userDetails.userProfileData,
    helpMail: state.common.helpMail,
    contactSuccessMail: state.common.toMailId,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentHelpModal);
